const PropertySettingsCustomDataTab = () => {
  return <div>TODO custom data</div>;
};

export default PropertySettingsCustomDataTab;
